module.exports = __webpack_public_path__ + "static/media/8786.5919550d.png";